import React from 'react';

import styled from 'styled-components';

const StyledDiv = styled.div({
    position: 'absolute',
    display: 'block',
    top: '0px',
    transition: 'all 0.3s ease-in-out',
    overflow: 'hidden',

    '& .bg-xl': {


        '@media (max-width: 1920px)': {
            width: '120%',
            marginTop: '-100px',
            height: 'auto',
            marginLeft: '-150px',
            transition: 'all 0.3s ease-in-out',
            display: 'block',
        },

        '@media (max-width: 1280px)': {
            display: 'none',
        },

        '@media (max-width: 960px)': {
            display: 'none',
        },
    },

    '& .bg-lg': {
        display: 'none',

        '@media (max-width: 1920px)': {
            display: 'none',
        },

        '@media (max-width: 1280px)': {
            width: '120%',
            height: 'auto',
            marginTop: '-400px',
            marginLeft: '-150px',
            transform: 'scaleY(-1)',
            display: 'block',
            transition: 'all 0.3s ease-in-out',
        },

        '@media (max-width: 960px)': {
            display: 'none',
        }
    },

    '& .bg-md': {
        display: 'none',

        '@media (max-width: 1920px)': {
            display: 'none',
        },

        '@media (max-width: 1280px)': {
            display: 'none',
        },

        '@media (max-width: 960px)': {
            width: '100%',
            height: 'auto',
            transform: 'rotate(90deg)',
            marginTop: '-300px',
            marginLeft: '40px',
            display: 'block',
            transition: 'all 0.3s ease-in-out',
        },

        '@media (max-width: 600px)': {
            display: 'none',
        }
    },

    '& .bg-sm': {
        display: 'none',

        '@media (max-width: 1920px)': {
            display: 'none',
        },

        '@media (max-width: 1280px)': {
            display: 'none',
        },

        '@media (max-width: 960px)': {
            display: 'none',
        },

        '@media (max-width: 600px)': {
            width: '120%',
            height: 'auto',
            // transform: 'rotate(90deg)',
            marginTop: '-300px',
            marginLeft: '40px',
            display: 'block',
            transition: 'all 0.3s ease-in-out',
        },

        '@media (max-width: 420px)': {
            display: 'none',
        }
    },

    '& .bg-ssm': {
        display: 'none',

        '@media (max-width: 1920px)': {
            display: 'none',
        },

        '@media (max-width: 1280px)': {
            display: 'none',
        },

        '@media (max-width: 960px)': {
            display: 'none',
        },

        '@media (max-width: 600px)': {
            display: 'none',
        },
        '@media (max-width: 420px)': {
            width: '150%',
            height: 'auto',
            // transform: 'rotate(90deg)',
            marginTop: '-300px',
            marginLeft: '40px',
            display: 'block',
            transition: 'all 0.3s ease-in-out',
        }
    },
})

function MainBackground() {
    return (
        <StyledDiv>
            <picture>
                <source srcSet='./images/membramna-inicio_min.webp' type='image/webp' />
                <source srcSet='./images/membramna-inicio_min.png' type='image/png' />
                <img alt='bg-main' src='./images/membramna-inicio_min.webp' className='bg-xl' />
            </picture>
            <picture>
                <source srcSet='./images/membramna-inicio_min.webp' type='image/webp' />
                <source srcSet='./images/membramna-inicio_min.png' type='image/png' />
                <img alt='bg-main' src='./images/membramna-inicio_min.webp' className='bg-lg' />
            </picture>
            <picture>
                <source srcSet='./images/membramna-inicio-sm_min.webp' type='image/webp' />
                <source srcSet='./images/membramna-inicio-sm_min.png' type='image/png' />
                <img alt='bg-main' src='./images/membramna-inicio-sm_min.webp' className='bg-md' />
            </picture>
            <picture>
                <source srcSet='./images/membramna-inicio-sm_min.webp' type='image/webp' />
                <source srcSet='./images/membramna-inicio-sm_min.png' type='image/png' />
                <img alt='bg-main' src='./images/membramna-inicio-sm_min.webp' className='bg-sm' />
            </picture>
            <picture>
                <source srcSet='./images/membramna-inicio-sm_min.webp' type='image/webp' />
                <source srcSet='./images/membramna-inicio-sm_min.png' type='image/png' />
                <img alt='bg-main' src='./images/membramna-inicio-sm_min.webp' className='bg-ssm' />
            </picture>
        </StyledDiv>
    );
}

export default MainBackground;
